import { HeroLayout, Index } from 'gatsby-theme-doctornpm';
import * as React from 'react';
export default {
  HeroLayout,
  Index,
  React
};